<template>
  <v-container class="wrapper d-flex flex-column" mt-8 mb-8>
    <div class="title">{{$t('paymentHistory.title')}}</div>
    <div class="p-tableHeader">
      <div
        class="p-tableColTitle
        "
      >
        {{$t('paymentHistory.planName')}}
      </div>
      <div
        class="p-tableColTitle
        "
      >
        {{$t('paymentHistory.amountPaid')}}
      </div>
      <div
        class="p-tableColTitle
        "
      >
        {{$t('paymentHistory.getDate')}}
      </div>
      <div
        class="p-tableColTitle
        "
      >
        {{$t('paymentHistory.countPages')}}
      </div>
      <!-- <div
        class="p-tableColTitle
        "
      >
        Төлөв
      </div> -->
      <div class="p-smallDesign">Худалдан авалтуудын мэдээлэл</div>
    </div>
    <div v-if="loading" class="loadingWrapper">
      <v-progress-circular
        :size="40"
        :width="3"
        color="#787ff7"
        indeterminate
      ></v-progress-circular>
    </div>
    <EmptyBox v-else-if="list.length == 0" />
    <template v-else v-for="item in list">
      <PaymentInfo
        :info="{
          planId: item.PlanID,
          pageCount: item.Quantity,
          boughtDate: item.CreatedAt,
          planCharacterCount :item.PlanCharacterCount
        }"
        :key="item.id"
        ><slot
      /></PaymentInfo>
    </template>
    <v-row v-if="list.length != 0" class="mt-auto">
      <v-col cols="12" align-self="end" class="d-flex justify-end">
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="6"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          color="#787ff7"
          circle
          @input="nextPage"
        ></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from "axios";
import { format } from "date-fns";
import { mapActions } from "vuex";
import PaymentInfo from "../components/PaymentInfo";
import EmptyBox from "../components/EmptyBox.vue";
export default {
  name: "Orders",
  components: { PaymentInfo, EmptyBox },
  data: () => ({
    dialog: false,
    list: [],
    downloading: true,
    playing: null,
    token: null,
    count: 0,
    page: 1,
    pageCount: 0,
    itemsPerPage: 8,
    loading: true,
  }),
  computed: {
    getToken: function() {
      return this.$cookie.get("token");
    },
  },
  mounted() {
    // this.getPurchasedList();
    this.getPurchasedHistory();
  },
  methods: {
    ...mapActions(["showErrorMessage", "showWarningMessage", "checkError"]),
    getPurchasedList() {
      const headers = {
        token: this.getToken,
        offset: (this.page - 1) * this.itemsPerPage,
        limit: this.itemsPerPage,
      };
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/getallpurchasedinfo`, { headers })
        .then((response) => {
          console.log(response);
          this.list = response.data.data.List;
          this.pageCount = Math.ceil(
            response.data.data.Count / this.itemsPerPage
          );
          console.log("list");
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.checkError(error);
        });
    },
    getPurchasedHistory() {
      const headers = {
        token: this.getToken,
      };
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/getPurchaseHistory?page=${this.page}&per_page=${this.itemsPerPage}`,
          { headers }
        )
        .then((response) => {
          if (response.data.data.List != null) {
            this.list = response.data.data.List;
            this.pageCount = Math.ceil(
              response.data.data.Count / this.itemsPerPage
            );
          }

          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.checkError(error);
        });
    },
    nextPage(page) {
      this.page = page;
      this.loading = true;
      this.getPurchasedHistory();
    },
    getFormatDate(date) {
      var currentDate = new Date(date);
      currentDate.setHours(currentDate.getHours());
      return format(currentDate, "yyyy/MM/dd HH:mm");
    },
    getPageCount(characterLength) {
      return Math.ceil(characterLength / 3750);
    },
  },
};
</script>
<style scoped>
.wrapper {
  display: flex;
  max-width: 1344px;
  min-height: 80%;
  border-radius: 15px;
  padding-bottom: 30px;
}

@media screen and (max-width: 1343px) {
  .wrapper {
    width: 90%;
  }
}
.loadingWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 520px;
}

.title {
  font-weight: 700;
  text-align: left;
  line-height: 23px;
  font-size: 20px;
  color: #000000;
  margin-bottom: 16px;
}

.position {
  text-align: right;
}

.fillBtn {
  background-color: #787ff7 !important;
  text-transform: initial;
  color: #ffffff;
  outline: none;
}

.outlineBtn {
  color: #787ff7;
  text-transform: initial;
  outline: none;
  z-index: 1;
}

.snackBar1 {
  color: green !important;
}

.circle {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50px;
}

.p-tableHeader {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 5px;
}

.p-tableColTitle {
  font-size: 14px;
  font-weight: 500;
  color: #767676;
  text-align: left;
}

.p-textStyle {
  font-size: 14px;
  font-weight: 500;
  color: #767676;
  text-align: left;
}

.p-smallDesign {
  display: none;
}

@media screen and (max-width: 768px) {
  .p-tableColTitle {
    display: none;
  }

  .p-smallDesign {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: #767676;
    text-align: left;
    border-bottom: 1px solid #e8ebed;
  }

  .p-tableHeader {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
